import React, { useState } from "react";
import {
  FaAndroid,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";


import {
  FaTag,
  FaBox,
  FaBarcode,
  FaLayerGroup,
  FaInfoCircle,
  FaRuler,
  FaClipboardList,
  FaSortAmountUp,
  FaCubes,
  FaHashtag,
  FaShieldAlt,
  FaCheckCircle,
  FaDollarSign,
  FaStickyNote,
  FaWarehouse,
  FaBalanceScale,
  FaEye,
  FaSearch,
} from "react-icons/fa";


import { MdDataUsage } from "react-icons/md";
import attributesImg from "../../../assets/Docs/add_atributes.png";
import { TagComponent } from "../Tabs";

const PreperingData = () => {
  const [activeTab1, setActiveTab1] = useState("web");
  const [activeTab2, setActiveTab2] = useState("web");
  const [activeTab3] = useState("web");
  const [activeTab4] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  const content2 = {
    web: "",
    mobile: "",
  };

  const content3 = {
    web: "",
    mobile: "",
  };
  const content4 = {
    web: "",
    mobile: "",
  };

  const attributes = [
    { icon: <FaBarcode />, label: "Code" },
    { icon: <FaTag />, label: "Name" },
    { icon: <FaLayerGroup />, label: "Category" },
    { icon: <FaLayerGroup />, label: "Category 1 (For Data Import Only)" },
    { icon: <FaLayerGroup />, label: "Category 2 (For Data Import Only)" },
    { icon: <FaBarcode />, label: "Product ID" },
    { icon: <FaClipboardList />, label: "SKU" },
    { icon: <FaBox />, label: "Variant" },
    { icon: <FaInfoCircle />, label: "Short Description" },
    { icon: <FaRuler />, label: "Size" },
    { icon: <FaClipboardList />, label: "Ordering Unit" },
    { icon: <FaSortAmountUp />, label: "Minimum Order Quantity" },
    { icon: <FaCubes />, label: "Order Multiple" },
    { icon: <FaBox />, label: "Packing" },
    { icon: <FaHashtag />, label: "HSN Code" },
    { icon: <FaShieldAlt />, label: "Warranty" },
    { icon: <FaCheckCircle />, label: "Stock Status" },
    {
      icon: <FaDollarSign />,
      label: "Price (Price 1 to Price 25 for supporting 25 different prices)",
    },
    { icon: <FaStickyNote />, label: "Notes" },
    { icon: <FaWarehouse />, label: "Warehouses" },
    { icon: <FaBalanceScale />, label: "Tax Tier" },
    { icon: <FaEye />, label: "Visibility Tier" },
    { icon: <FaSearch />, label: "Search Tags (comma separated)" },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
              ? "bg-[#1a9588] text-white shadow"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <MdDataUsage className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Preparing Data for Import</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <p className="text-start mb-6 text-gray-600 ">
        Using Excel import, you can swiftly and effortlessly set up your
        ‘Seller’ account and build your private product catalogue. The Excel
        import feature allows you to upload only the specific attributes listed
        below.
      </p>

      <div className=" mx-auto bg-white p-6 rounded shadow">
        <ul className="border border-gray-200 rounded divide-y divide-gray-200">
          {attributes.map((item, index) => (
            <li
              key={index}
              className="flex items-center gap-3 p-3 hover:bg-gray-50"
            >
              <span className="text-blue-500 text-lg">{item.icon}</span>
              <span className="text-gray-700">{item.label}</span>
            </li>
          ))}
        </ul>

        <p className="mt-4 text-gray-700 text-start">
          There are 2 options while importing data. First, when your products do
          not have any variations i.e. one product code is linked with only one
          size. The second option is when your products have multiple variations
          i.e. one product code is linked with multiple sizes.
        </p>

        <div className="mt-4 bg-yellow-100 text-yellow-800 p-3 rounded text-start">
          Selzor encourages you to download the Excel Template & use that
          template to import data.
        </div>
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 mb-2 font-semibold">
          One Product Code - One Size Only
        </h3>
        <p className="text-gray-400 mb-6">
          This option is straightforward. Create one row for each product code
          and complete all the required fields in every row.
        </p>
      </div>

      {renderTabs(activeTab1, setActiveTab1)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={attributesImg}
          alt={`${activeTab1} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>
      <div className="mt-4 bg-yellow-100 text-yellow-800 p-3 rounded text-start">
        You can use any spreadsheet program and then export your data to Excel
        format (.xls or .xlsx). The above screenshot is from Apple Numbers. You
        can use Microsoft Excel or Google Sheets also.
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2">
          One Product Code - Multiple Sizes
        </h3>
        <p className="text-gray-400 mb-6">
          This option adds one extra step. Prepare your Excel file as usual, but
          create a separate row for each size. Your sheet will appear similar to
          the screenshot shown below.
        </p>
      </div>

      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={content2[activeTab2]}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <p className="text-gray-400 mb-6 text-start">
        Next, we must complete every row to ensure the Selzor App imports the
        Excel file without errors. To achieve this, we begin filling in all the
        empty rows.
      </p>

      <div className="mt-4 bg-yellow-100 text-yellow-800 p-3 rounded text-start">
        Copy the rows which are common for all sizes like the Code, Name,
        Category & Category1 in our example.
      </div>

      <div className="my-4">
        {/* {renderTabs(activeTab1, setActiveTab1)} */}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={content3[activeTab3]}
            alt={`${activeTab3} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>

        <p className="text-gray-400 mb-6 text-start">
          And finally your excel file will look like the screenshot below
        </p>
      </div>

      <div className="my-4">
        {/* {renderTabs(activeTab1, setActiveTab1)} */}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start ">
          <img
            src={content4[activeTab4]}
            alt={`${activeTab4} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>

        <p className="text-gray-400 mb-6 text-start">
          You are now ready to import this Excel file.
        </p>
      </div>
    </div>
  );
};

export default PreperingData;
